import React from "react";
import { useField } from "formik";


export default function RadioField({
  label,
  name,
  fullWidth,
  required,
  options = [],
  row = true,
}) {
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;
 const getFontSize = () => {
    const width = window.innerWidth;
    if (width < 480) return "0.75rem";
    if (width < 768) return "0.875rem";
    return "1rem";
  };
  const showError = meta.touched && meta.error;

  return (
    <div className={`${fullWidth ? "col-md-12" : "col-md-6"} mb-3`}>
      {label && (
        <label
          className="form-label text-capitalize"
          style={{ fontSize: getFontSize() }}
          htmlFor={field.name}
        >
          {label}
          {required && <span className="text-danger">*</span>}
        </label>
      )}

      <div
        className={`form-check-group ${row ? "d-flex gap-3" : "d-block mb-2"}`}
      >
        {options.map((option) => (
          <div className="form-check" key={option.value}>
            <input
              className="form-check-input"
              type="radio"
              name={name}
              value={option.value}
              checked={field.value === option.value}
              onChange={() => setValue(option.value)}
              id={`${name}_${option.value}`}
            />
            <label
              className="form-check-label fs-6 text-capitalize"
              htmlFor={`${name}_${option.value}`}
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>

      {showError && <div className="text-danger">{meta.error}</div>}
    </div>
  );
}
